// extracted by mini-css-extract-plugin
module.exports = {"container":"TransferHeader_container__joWsk","title":"TransferHeader_title___LudR","separator":"TransferHeader_separator__czdvk","content":"TransferHeader_content____Ot_"};